import { ProductComplianceLabelTypeEnum, ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
export default class RepairabilityIndexUtility {
    /**
     * Get the URL to the repairability index document with a specific fileType.
     *
     * @param product The product.
     * @param fileType The specific fileType of the document.
     * @returns The URL to the repairability index document, or null if not found.
     */
    static getDocumentUrl(product, fileType) {
        return (product.content?.complianceLabel?.find((label) => label.labelType === ProductComplianceLabelTypeEnum.repairabilityIndexDocument &&
            label.fileType === fileType)?.url ?? null);
    }
    /**
     * Get the URL to the repairability index image with a specific fileType.
     *
     * @param product The product.
     * @param fileType The specific fileType of the image.
     * @returns The URL to the repairability index image, or null if not found.
     */
    static getImageUrl(product, fileType) {
        return (product.content?.complianceLabel?.find((label) => label.labelType === ProductComplianceLabelTypeEnum.repairabilityIndexImage &&
            label.fileType === fileType)?.url ?? null);
    }
    /**
     * Get an alt text which represents the repairability index.
     *
     * @param product The product.
     * @returns An alt text.
     */
    static getImageAltText(product) {
        const repairabilityIndex = product.content?.complianceTechnical?.find((item) => item.headingType === ProductComplianceTechnicalHeadingTypeEnum.repairabilityIndex);
        if (!repairabilityIndex) {
            return '';
        }
        return `${repairabilityIndex.headingText}: ${repairabilityIndex.text}`;
    }
}
//# sourceMappingURL=RepairabilityIndexUtility.js.map